<template>
  <div
    :class="['tips-container', 'question-btn', gameName, displayModeClassName]"
    v-if="show"
  >
    <span class="tips-text">{{ $t('free-fire.first_time_bonus') }}</span>
    <template>
      <img
        v-if="!isDesktop"
        class="tips-icon"
        :src="require(`@/assets/images/detail/common/tips.png`)"
        @click="handlePopupClick"
        alt="tips-icon"
      />
      <MBIcon
        @click="handlePopupClick"
        color="#FFD763"
        name="icon-question"
        :size="18"
        v-else
      />
    </template>
    <van-dialog
      v-model="showPopover"
      :show-confirm-button="false"
      :show-cancel-button="false"
      :closeOnClickOverlay="true"
      className="popover-wrapper"
    >
      <div class="tips-title">{{ $t('free-fire.first_time_bonus') }}</div>
      <MBIcon
        defaultClass="colour"
        @click="handlePopupClick"
        name="c-close-grey"
        :size="closeSize"
      />
      <div class="tips-desc-box">
        <span
          v-for="(desc, index) in tipsDesc"
          :key="index"
          class="tips-desc"
          >{{ desc }}</span
        >
      </div>
      <div class="tips-details-box">
        <span
          class="tips-details"
          v-for="(detail, index) in tipsDetail"
          :key="index"
          >{{ detail }}</span
        >
      </div>
    </van-dialog>
  </div>
</template>

<script>
  import MBIcon from '@/components/MBIcon'
  import { mapState, mapGetters } from 'vuex'
  import { textFormat } from '@/utils/pluralRules.js'

  const rules = [
    [61, 7, 68],
    [156, 16, 172],
    [281, 29, 310],
    [470, 47, 517],
    [956, 96, 1052],
    [1637, 164, 1801],
    [3361, 337, 3698],
  ]

  export default {
    props: {
      type: {
        default: '',
        type: String,
      },
    },
    components: {
      MBIcon,
    },
    data() {
      return {
        show: false,
        showPopover: false,
      }
    },
    computed: {
      ...mapState([
        'gameName',
        'region',
        'isDesktop',
        'isTurbo',
        'hotfixIsFetchSuccess',
      ]),
      ...mapGetters(['displayModeClassName']),
      tipsDesc() {
        return [
          this.$t('free-fire.bonus_desc_1'),
          this.$t('free-fire.bonus_desc_2'),
          this.$t('free-fire.bonus_desc_3'),
        ]
      },
      tipsDetail() {
        let local = this.$t('free-fire.bonus_detail')
        if (!local || !local.includes('{')) {
          return []
        }
        const originLocalArr = local
          .split('}}')
          .map((item) => (item.includes('{') ? item + '}}' : item))

        const localArr = originLocalArr.filter((item) => item.includes('{'))
        const lastLocalArr = originLocalArr.filter(
          (item) => !item.includes('{')
        )
        let result = rules.map(
          (item, index) =>
            +index +
            1 +
            '.' +
            ' ' +
            item
              .map((val, i) => textFormat(localArr[i], val))
              .concat(lastLocalArr)
              .join('')
        )
        return result
      },
      closeSize() {
        return this.isDesktop ? 46 : this.isTurbo ? 80 : 70
      },
    },
    watch: {
      hotfixIsFetchSuccess: function (val) {
        if (val) this.showFFBonus()
      },
    },
    methods: {
      handlePopupClick() {
        this.showPopover = !this.showPopover
      },
      showFFBonus() {
        this.show = !!(window && window.showFFBonus)
      },
    },
  }
</script>

<style lang="scss" src="./popover.scss" scoped></style>
<style lang="scss" scoped>
  .free-fire {
    &.tips-container {
      margin-top: 15px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .tips-text {
        font-size: 33px;
        color: #ffd763;
        line-height: 44px;
        margin-right: 10px;
      }
      .tips-icon {
        width: 42px;
        height: 42px;
        margin-left: 0px;
      }

      ::v-deep .popover-wrapper {
        padding: 75px 60px 57px;
        width: calc(100%-120px);
        max-height: 1102px;
        background-color: #39304d;
        border-radius: 36px;
        top: 50%;
        .van-dialog__content {
          max-height: 970px;
          overflow-y: auto;
        }
        color: #ffffff;
      }

      .tips-title {
        font-size: 45px;
        font-weight: 600;
        line-height: 45px;
        text-align: center;
        margin: 0 auto;
        margin-bottom: 45px;
        max-width: 750px;
      }

      .tips-desc-box {
        font-size: 36px;
        line-height: 1.3;
        .tips-desc {
          display: block;
          margin-bottom: 30px;
        }
      }

      .tips-details-box {
        font-size: 36px;
        line-height: 1.3;
        .tips-details {
          display: block;
          margin-bottom: 20px;
        }
      }

      .mb-c-close-grey {
        position: absolute;
        top: 30px;
        right: 30px;
        border-radius: 50%;
        cursor: pointer;
      }
    }

    // pc
    &.display-desktop {
      &.tips-container {
        margin-top: 0;
        margin-left: 14px;
        .tips-text {
          font-size: 20px;
          line-height: 20px;
          margin-right: 8px;
          color: #ffd763;
        }

        ::v-deep .popover-wrapper {
          padding: 45px;
          width: 658px;
          max-height: 736px;
          border-radius: 30px;
          top: 50%;
          .van-dialog__content {
            max-height: 646px;

            @include scrollingBar();
            &::-webkit-scrollbar-thumb {
              background: rgba(255, 255, 255, 0.1);
            }
          }
        }

        .tips-title {
          font-size: 28px;
          margin-bottom: 24px;
          line-height: 45px;
          max-width: 522px;
        }

        .tips-desc-box {
          font-size: 26px;
          .tips-desc {
            margin-bottom: 24px;
          }
        }

        .tips-details-box {
          font-size: 26px;
          .tips-details {
            margin-bottom: 16px;
          }
        }

        .mb-c-close-grey {
          top: 20px;
          right: 20px;
        }
      }
    }

    // gt
    &.display-game-turbo {
      &.tips-container {
        .tips-text {
          color: #ffd763;
        }

        .tips-title {
          font-size: 42px;
          line-height: 56px;
          margin-bottom: 30px;
        }
      }
    }
  }
</style>
